import {
  concat,
  findIndex,
  forEach,
  get,
  isArray,
  uniq,
  values,
} from "lodash-es";

export default function FiltersCombineCopiesAPI() {
  const onCombineCopiesData = ({ list, filter }) => {
    const KEY_ID = filter.keyId || "id";
    const KEY_LABEL = filter.keyLabel || "label";
    const LIST_COPY_OBJ = {};
    forEach(list, item => {
      if (LIST_COPY_OBJ[item[KEY_LABEL]]) {
        LIST_COPY_OBJ[item[KEY_LABEL]][KEY_ID] = `${ LIST_COPY_OBJ[item[KEY_LABEL]][KEY_ID] }_${ item[KEY_ID] }`;
      } else {
        LIST_COPY_OBJ[item[KEY_LABEL]] = item;
      }
    });
    return values(LIST_COPY_OBJ);
  };

  const checkFilterModelForCombineCopies = ({ filter, list, CURRENT_MODEL }) => {
    let currentModelNew = [];
    const TEMP_OBJ = {};
    if (isArray(CURRENT_MODEL)) {
      forEach(CURRENT_MODEL, model => {
        const MODEL_SPLIT = model.split("_");
        forEach(MODEL_SPLIT, modSplit => {
          const INDEX = findIndex(list, item => {
            return item[filter.keyId].indexOf(modSplit) !== -1;
          });

          if (INDEX !== -1) {
            if (list[INDEX][filter.keyId] !== modSplit) {
              if (!TEMP_OBJ[list[INDEX][filter.keyLabel]]) {
                TEMP_OBJ[list[INDEX][filter.keyLabel]] = {
                  indexInList: INDEX,
                  ids: [],
                };
              }

              TEMP_OBJ[list[INDEX][filter.keyLabel]].ids = uniq(concat(TEMP_OBJ[list[INDEX][filter.keyLabel]].ids, [modSplit]));
            } else {
              currentModelNew.push(modSplit);
            }
          }
        });
      });
    } else {
      const MODEL_SPLIT = CURRENT_MODEL.split("_");
      forEach(MODEL_SPLIT, modSplit => {
        const INDEX = findIndex(list, item => {
          return item[filter.keyId].indexOf(modSplit) !== -1;
        });

        if (INDEX !== -1) {
          if (list[INDEX][filter.keyId] !== modSplit) {
            TEMP_OBJ[list[INDEX][filter.keyLabel]] = {
              indexInList: INDEX,
              ids: uniq(concat(get(TEMP_OBJ[list[INDEX][filter.keyLabel]], "ids", []), [modSplit])),
            };
          } else {
            currentModelNew = list[INDEX][filter.keyId];
          }
        }
      });
    }

    forEach(TEMP_OBJ, (item, key) => {
      const ID_SPLIT = list[item.indexInList][filter.keyId].split("_");
      if (ID_SPLIT.length !== item.ids.length) {
        const ID_JOIN = item.ids.join("_");
        const INDEX_IN_LIST = findIndex(list, [filter.keyId, ID_JOIN]);
        if (INDEX_IN_LIST === -1) { // Es gibt noch nicht
          list.push({ // New element
            [filter.keyId]: ID_JOIN,
            [filter.keyLabel]: `${ key } (teilweise ${ item.ids.length }/${ ID_SPLIT.length })`,
          });
        }
        currentModelNew.push(ID_JOIN);
      } else {
        currentModelNew.push(list[item.indexInList][filter.keyId]);
      }
    });
    return { currentModelNew, statusChangeModel: true };
  };

  return {
    onCombineCopiesData,
    checkFilterModelForCombineCopies,
  };
}
